export default function Aida() {
  return (
    <div>
      <p>
        It combines the power of generative AI with the capabilities of the DISGENET REST API. You can ask
        questions in natural language and the assistant will translate them to structured queries to the
        database exploiting all the features available in DISGENET, and summarize the main results for you.
        The DISGENET AI assistant lowers the barrier to access DISGENET for users with no programming skills
        and no knowledge about DISGENET data schema. Try it{' '}
        <a href="/Assistant" target="_blank" rel="noopener noreferrer">
          here
        </a>
        .
      </p>

      <h6 className="mt-4 font-semibold">Request limits</h6>
      <p className="text-sm opacity-80 mb-2">
        To keep AIDA fast and dependable for everyone, usage is capped over several time windows. Limits help
        prevent overload and abuse; if you hit a cap, wait until your quota refreshes before sending more
        queries. Exact caps are listed below.
      </p>

      <div className="table-responsive mt-3">
        <table className="table table-bordered table-striped" style={{ fontSize: '0.9rem' }}>
          <thead className="table-light">
            <tr>
              <th scope="col">Time window</th>
              <th scope="col">Maximum requests</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1 minute</td>
              <td>5</td>
            </tr>
            <tr>
              <td>1 day</td>
              <td>50</td>
            </tr>
            <tr>
              <td>7 days</td>
              <td>200</td>
            </tr>
            <tr>
              <td>1 calendar month</td>
              <td>1,000</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
